let reloaded = false;
export function installChunkReload() {
  window.addEventListener(
    "error",
    (e: any) => {
      const msg = String(e?.message || "");
      if (/Loading chunk|ChunkLoadError|import\(\) failed/i.test(msg) && !reloaded) {
        reloaded = true;
        // évite boucle infinie si le même build est encore servi
        const url = new URL(location.href);
        url.searchParams.set("v", String(Date.now()));
        location.replace(url.toString());
      }
    },
    true,
  );
  window.addEventListener("unhandledrejection", (e: any) => {
    const msg = String(e?.reason?.message || e?.reason || "");
    if (/Loading chunk|ChunkLoadError|import\(\) failed/i.test(msg) && !reloaded) {
      reloaded = true;
      const url = new URL(location.href);
      url.searchParams.set("v", String(Date.now()));
      location.replace(url.toString());
    }
  });
}
